/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Export this preset" |
*
* @param {Preset_Manager_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_title = /** @type {((inputs?: Preset_Manager_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter ce preset")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Voreinstellung exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta questo preset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт этого пресета")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar este ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出此预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプリセットをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस प्रीसेट को निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exporte esta predefinição.")
	return /** @type {LocalizedString} */ ("Export this preset")
});